export type SampleVerse = {
  ref: string;
  number: number;
  text: string;
};

export type SampleChapter = {
  bookId: string;
  bookName: string;
  chapter: number;
  language: { iso639_3: string; bcp47: string };
  source: { translation: string; license: string };
  verses: SampleVerse[];
};

export const matthew1: SampleChapter = {
  bookId: 'MAT',
  bookName: 'Matthew',
  chapter: 1,
  language: { iso639_3: 'eng', bcp47: 'en' },
  source: { translation: 'King James Version', license: 'Public domain' },
  verses: [
    { ref: 'Mat.1.1', number: 1, text: 'The book of the generation of Jesus Christ, the son of David, the son of Abraham.' },
    { ref: 'Mat.1.2', number: 2, text: 'Abraham begat Isaac; and Isaac begat Jacob; and Jacob begat Judas and his brethren;' },
    { ref: 'Mat.1.3', number: 3, text: 'And Judas begat Phares and Zara of Thamar; and Phares begat Esrom; and Esrom begat Aram;' },
    { ref: 'Mat.1.16', number: 16, text: 'And Jacob begat Joseph the husband of Mary, of whom was born Jesus, who is called Christ.' },
    { ref: 'Mat.1.17', number: 17, text: 'So all the generations from Abraham to David are fourteen generations; and from David until the carrying away into Babylon are fourteen generations; and from the carrying away into Babylon unto Christ are fourteen generations.' },
    { ref: 'Mat.1.18', number: 18, text: 'Now the birth of Jesus Christ was on this wise: When as his mother Mary was espoused to Joseph, before they came together, she was found with child of the Holy Ghost.' },
    { ref: 'Mat.1.20', number: 20, text: 'But while he thought on these things, behold, the angel of the Lord appeared unto him in a dream, saying, Joseph, thou son of David, fear not to take unto thee Mary thy wife: for that which is conceived in her is of the Holy Ghost.' },
    { ref: 'Mat.1.21', number: 21, text: 'And she shall bring forth a son, and thou shalt call his name JESUS: for he shall save his people from their sins.' },
    { ref: 'Mat.1.22', number: 22, text: 'Now all this was done, that it might be fulfilled which was spoken of the Lord by the prophet, saying,' },
    { ref: 'Mat.1.23', number: 23, text: 'Behold, a virgin shall be with child, and shall bring forth a son, and they shall call his name Emmanuel, which being interpreted is, God with us.' },
  ],
};

export const matthew2: SampleChapter = {
  bookId: 'MAT',
  bookName: 'Matthew',
  chapter: 2,
  language: { iso639_3: 'eng', bcp47: 'en' },
  source: { translation: 'King James Version', license: 'Public domain' },
  verses: [
    { ref: 'Mat.2.1', number: 1, text: 'Now when Jesus was born in Bethlehem of Judaea in the days of Herod the king, behold, there came wise men from the east to Jerusalem,' },
    { ref: 'Mat.2.5', number: 5, text: 'And they said unto him, In Bethlehem of Judaea: for thus it is written by the prophet,' },
    { ref: 'Mat.2.6', number: 6, text: 'And thou Bethlehem, in the land of Juda, art not the least among the princes of Juda: for out of thee shall come a Governor, that shall rule my people Israel.' },
    { ref: 'Mat.2.11', number: 11, text: 'And when they were come into the house, they saw the young child with Mary his mother, and fell down, and worshipped him: and presented unto him gifts; gold, and frankincense, and myrrh.' },
    { ref: 'Mat.2.13', number: 13, text: 'And when they were departed, behold, the angel of the Lord appeareth to Joseph in a dream, saying, Arise, and take the young child and his mother, and flee into Egypt, and be thou there until I bring thee word: for Herod will seek the young child to destroy him.' },
    { ref: 'Mat.2.14', number: 14, text: 'When he arose, he took the young child and his mother by night, and departed into Egypt:' },
    { ref: 'Mat.2.21', number: 21, text: 'And he arose, and took the young child and his mother, and came into the land of Israel.' },
    { ref: 'Mat.2.23', number: 23, text: 'And he came and dwelt in a city called Nazareth: that it might be fulfilled which was spoken by the prophets, He shall be called a Nazarene.' },
  ],
};

export const john3: SampleChapter = {
  bookId: 'JHN',
  bookName: 'John',
  chapter: 3,
  language: { iso639_3: 'eng', bcp47: 'en' },
  source: { translation: 'King James Version', license: 'Public domain' },
  verses: [
    { ref: 'Jhn.3.14', number: 14, text: 'And as Moses lifted up the serpent in the wilderness, even so must the Son of man be lifted up:' },
    { ref: 'Jhn.3.15', number: 15, text: 'That whosoever believeth in him should not perish, but have eternal life.' },
    { ref: 'Jhn.3.16', number: 16, text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.' },
    { ref: 'Jhn.3.17', number: 17, text: 'For God sent not his Son into the world to condemn the world; but that the world through him might be saved.' },
    { ref: 'Jhn.3.18', number: 18, text: 'He that believeth on him is not condemned: but he that believeth not is condemned already, because he hath not believed in the name of the only begotten Son of God.' },
    { ref: 'Jhn.3.19', number: 19, text: 'And this is the condemnation, that light is come into the world, and men loved darkness rather than light, because their deeds were evil.' },
    { ref: 'Jhn.3.20', number: 20, text: 'For every one that doeth evil hateth the light, neither cometh to the light, lest his deeds should be reproved.' },
    { ref: 'Jhn.3.21', number: 21, text: 'But he that doeth truth cometh to the light, that his deeds may be made manifest, that they are wrought in God.' },
  ],
};

export const matthew6: SampleChapter = {
  bookId: 'MAT',
  bookName: 'Matthew',
  chapter: 6,
  language: { iso639_3: 'eng', bcp47: 'en' },
  source: { translation: 'King James Version', license: 'Public domain' },
  verses: [
    { ref: 'Mat.6.9', number: 9, text: 'After this manner therefore pray ye: Our Father which art in heaven, Hallowed be thy name.' },
    { ref: 'Mat.6.10', number: 10, text: 'Thy kingdom come. Thy will be done in earth, as it is in heaven.' },
    { ref: 'Mat.6.11', number: 11, text: 'Give us this day our daily bread.' },
    { ref: 'Mat.6.12', number: 12, text: 'And forgive us our debts, as we forgive our debtors.' },
    { ref: 'Mat.6.13', number: 13, text: 'And lead us not into temptation, but deliver us from evil: For thine is the kingdom, and the power, and the glory, for ever. Amen.' },
    { ref: 'Mat.6.14', number: 14, text: 'For if ye forgive men their trespasses, your heavenly Father will also forgive you:' },
    { ref: 'Mat.6.15', number: 15, text: 'But if ye forgive not men their trespasses, neither will your Father forgive your trespasses.' },
  ],
};

export const SAMPLE_CHAPTERS = [matthew1, matthew2, matthew6, john3];

export function sampleChapterFor(book: string, chapter: number): SampleChapter | null {
  const upper = book.toUpperCase();
  return SAMPLE_CHAPTERS.find((c) => c.bookId === upper && c.chapter === chapter) ?? null;
}
